import React from 'react';
import { useInitialNavigation } from './useInitialNavigation';
import { Room } from '../models/Room';

interface InitialNavigationWrapperProps {
    onRoomsLoaded: (rooms: Room[]) => void;
    setRoomsLoaded: (loaded: boolean) => void;
}

/**
 * useInitialNavigation 훅을 사용하는 래퍼 컴포넌트
 * BrowserRouter 내부에서만 사용 가능하므로 별도 컴포넌트로 분리
 */
export const InitialNavigationWrapper: React.FC<InitialNavigationWrapperProps> = ({
    onRoomsLoaded,
    setRoomsLoaded
}) => {
    useInitialNavigation((rooms) => {
        onRoomsLoaded(rooms);
        setRoomsLoaded(true);
    });

    return null; // UI를 렌더링하지 않음
};
